import React from 'react';
import './ImagesPage.css'
const ImagesPage = () => {
    const data = Response;
    console.log(data)
    
    return (
        <div>
          {data?.items.map(item =>(
                    <div className='search__page--result'>
                       <a href={item.link}>
                       {item.pagemap?.cse_image?.
                       length > 0 && item.pagemap?.
                       cse_image[0].src && (<img alt="" className='search__page--result-img' 
                        src={item.pagemap?.cse_image[0]?.src}
                        /> )}         
                        </a> 
                    </div>
                ))}
                        
        </div>
    );
}

export default ImagesPage;
